import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "table"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = ["href"];
import { reactive, onMounted } from 'vue';
import { useMaxioSubscriptionStore } from './useMaxioSubscriptionStore.js';
import LlHtmlViewerIframe from '@/components/LlHtmlViewerIframe.vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
export default {
  __name: 'MaxioCompanySubscriptionInvoice',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    isSmallScreen: {
      type: Boolean,
      required: true
    }
  },
  setup(__props) {
    const props = __props;

    // Access feature flags
    const meStore = useMeStore();
    const {
      features
    } = storeToRefs(meStore);
    const subscriptionInvoiceState = reactive({
      loading: false,
      balance: 0,
      next: null,
      open: [],
      paid: [],
      invoices: []
    });
    const maxioCompanySubscriptionStore = useMaxioSubscriptionStore();
    maxioCompanySubscriptionStore.alerts = props.alerts;
    onMounted(async () => {
      subscriptionInvoiceState.loading = true;
      const list = await maxioCompanySubscriptionStore.getSubscriptionInvoices();
      subscriptionInvoiceState.balance = list.balance;
      subscriptionInvoiceState.next = list.next;
      subscriptionInvoiceState.open = list.open;
      subscriptionInvoiceState.paid = list.paid;
      subscriptionInvoiceState.invoices = list.invoices;
      subscriptionInvoiceState.loading = false;
    });
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_v_progress_circular, {
        color: "success",
        indeterminate: ""
      })], 512), [[_vShow, subscriptionInvoiceState.loading]]), _withDirectives(_createElementVNode("div", null, [_withDirectives(_createElementVNode("p", null, [_cache[0] || (_cache[0] = _createTextVNode(" Account balance: ", -1)), _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(subscriptionInvoiceState.balance)), 1), _cache[1] || (_cache[1] = _createTextVNode(" (due) ", -1))], 512), [[_vShow, subscriptionInvoiceState.balance > 0 && !_unref(features)?.customPricing]]), _withDirectives(_createElementVNode("p", null, [_cache[2] || (_cache[2] = _createTextVNode(" Account balance: ", -1)), _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(-subscriptionInvoiceState.balance)), 1), _cache[3] || (_cache[3] = _createTextVNode(" (credit) ", -1))], 512), [[_vShow, subscriptionInvoiceState.balance < 0 && !_unref(features)?.customPricing]]), _createElementVNode("table", _hoisted_1, [_createElementVNode("thead", null, [_createElementVNode("tr", null, [_cache[4] || (_cache[4] = _createElementVNode("th", null, "Date", -1)), _cache[5] || (_cache[5] = _createElementVNode("th", null, "Description", -1)), !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("th", _hoisted_2, "Amount")) : _createCommentVNode("", true), !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("th", _hoisted_3, "Balance")) : _createCommentVNode("", true), _cache[6] || (_cache[6] = _createElementVNode("th", null, null, -1))])]), _createElementVNode("tbody", null, [_cache[9] || (_cache[9] = _createElementVNode("tr", null, [_createElementVNode("td", {
        colspan: "5"
      }, [_createElementVNode("b", null, "Upcoming Invoice")])], -1)), _withDirectives(_createElementVNode("tr", null, [_createElementVNode("td", null, _toDisplayString(subscriptionInvoiceState.next?.date ? _ctx.formatDate(subscriptionInvoiceState.next.date) : ''), 1), _createElementVNode("td", null, [_createVNode(LlHtmlViewerIframe, {
        htmlContent: subscriptionInvoiceState.next?.description
      }, null, 8, ["htmlContent"])]), !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(_ctx.formatCurrency(subscriptionInvoiceState?.next?.total)), 1)) : _createCommentVNode("", true), !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("td", _hoisted_5, "upcoming")) : _createCommentVNode("", true), _cache[7] || (_cache[7] = _createElementVNode("td", null, null, -1))], 512), [[_vShow, subscriptionInvoiceState.next]]), _cache[10] || (_cache[10] = _createElementVNode("tr", null, [_createElementVNode("td", {
        colspan: "5"
      }, [_createElementVNode("b", null, "Invoices")])], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subscriptionInvoiceState?.invoices, (invoice, ids) => {
        return _openBlock(), _createElementBlock("tr", {
          key: ids
        }, [_createElementVNode("td", null, _toDisplayString(_ctx.formatDate(invoice.date)), 1), _createElementVNode("td", null, [_createElementVNode("span", {
          innerHTML: invoice.description
        }, null, 8, _hoisted_6)]), !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("td", _hoisted_7, _toDisplayString(_ctx.formatCurrency(invoice.total)), 1)) : _createCommentVNode("", true), !_unref(features)?.customPricing ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(invoice.paid ? 'paid' : _ctx.formatCurrency(invoice.amount)), 1)) : _createCommentVNode("", true), _createElementVNode("td", null, [invoice.link ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: invoice.link,
          target: "_blank",
          rel: "noopener noreferrer"
        }, [...(_cache[8] || (_cache[8] = [_createTextVNode("View", -1), _createElementVNode("span", {
          class: "fa fa-external-link ml-2"
        }, null, -1)]))], 8, _hoisted_9)) : _createCommentVNode("", true)])]);
      }), 128))])]), _cache[11] || (_cache[11] = _createElementVNode("p", {
        class: "text-sm text-gray-500 mt-2"
      }, " Invoices from before May 2024 will not be shown. ", -1))], 512), [[_vShow, !subscriptionInvoiceState.loading]])]);
    };
  }
};